import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationGrey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.99964 11.8196C12.0051 11.8196 13.636 10.1887 13.636 8.18324C13.636 6.17778 12.0051 4.54688 9.99964 4.54688C7.99419 4.54688 6.36328 6.17778 6.36328 8.18324C6.36328 10.1887 7.99419 11.8196 9.99964 11.8196ZM9.99964 6.36506C11.0024 6.36506 11.8178 7.18051 11.8178 8.18324C11.8178 9.18597 11.0024 10.0014 9.99964 10.0014C8.99692 10.0014 8.18146 9.18597 8.18146 8.18324C8.18146 7.18051 8.99692 6.36506 9.99964 6.36506Z",
		fill: "#525252"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.4721 18.9229C9.62596 19.0328 9.8103 19.0918 9.99937 19.0918C10.1884 19.0918 10.3728 19.0328 10.5266 18.9229C10.803 18.7274 17.2985 14.0374 17.2721 8.18288C17.2721 4.17288 14.0094 0.910156 9.99937 0.910156C5.98937 0.910156 2.72664 4.17288 2.72664 8.17834C2.70028 14.0374 9.19573 18.7274 9.4721 18.9229ZM9.99937 2.72834C13.0076 2.72834 15.4539 5.1747 15.4539 8.18743C15.473 12.222 11.4648 15.8447 9.99937 17.0329C8.53482 15.8438 4.52573 12.2202 4.54482 8.18288C4.54482 5.1747 6.99119 2.72834 9.99937 2.72834Z",
		fill: "#525252"
	})]
});
export default SvgLocationGrey;
